export default __webpack_public_path__ + "static/media/coin.9f144860.png";